import { useQuery } from "@tanstack/react-query";
import { creditApi } from "@/lib/credit.api";
import { queryKeys } from "@/lib/query-keys";

export function useCreditLotEntries(lotId: number | null) {
  return useQuery({
    queryKey: queryKeys.creditLotEntries(lotId ?? 0),
    queryFn: () => creditApi.listEntries(lotId!).then((r) => r.data),
    enabled: lotId !== null,
  });
}
